import type { AgentThemeTokens } from '../config/types'

export const baseTheme: AgentThemeTokens = {
  background: '#050505',
  surface: '#0f0f11',
  text: '#f7f7f7',
  subtext: '#8f9baa',
  border: '#1f2229',
  accent: '#6c63ff',
  accentSoft: 'rgba(108, 99, 255, 0.14)',
  warning: '#ffb347',
  danger: '#ff5f56',
  fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  radius: '12px',
  fontSize: '14px',
  colorMode: 'light'
}

export const mergeTheme = (overrides?: Partial<AgentThemeTokens>): AgentThemeTokens => ({
  ...baseTheme,
  ...overrides
})
